<template>
  <div>
    <div ref="child_popper" class="popper-container">
      <div class="desc__info text-dark" v-if="isTooltip">
        <div v-html="activeSubjectTypeDesc" v-if="isTooltipPopperDone"></div>
      </div>
    </div>
    <div class="subject-types text-dark" :class="{'subject-types--focus': isFormElementActive}">
      <div class="subject-types__type"
           :class="{'subject-types__type--selected': selectedtype === subjectType.value}"
           v-for="subjectType in activeSubjectTypes" :key="subjectType.value"
           @click="selectedtype = subjectType.value">
        <input type="radio"
               v-model="selectedtype"
               :value="subjectType.value"
               name="subject[subject_type]"
               :id="'subject_subject_type_' + subjectType.value">
        <label :for="'subject_subject_type_' + subjectType.value" v-html="subjectType.name"></label>
        <div class="desc" ref="parent_popper" @mouseenter="showTooltip(subjectType.desc, $event)"
             @mouseleave="hideTooltip">
          <svg width="16px" height="16px" viewBox="0 0 16 16">
            <g id="Artboard-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group-2">
                <circle id="Oval-10" fill="#a2a3a6" cx="8" cy="8" r="8"></circle>
                <path
                  d="M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z"
                  id="?" fill="#FFFFFF"></path>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import docendo from '../../docendo'
import {createPopper} from '@popperjs/core'
import subjectNo from '../../assets/img/info/no/subject.png'
import optionalNo from '../../assets/img/info/no/optional.png'
import frameNo from '../../assets/img/info/no/frame.png'

export default {
  props: {
    calendarType: {
      default: 'klass'
    },
    subjectType: {
      default: ''
    },
    isInTasks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      calSubjectTypes: [],
      allTypes: {
        'subject': [
          {
            lang: 'da',
            name: 'Fag <span class="do-bagde-break">UV-tid</span>',
            value: 'subject',
            order: 1,
            desc: 'Tæller UV-tid. To samtidige brikker tæller halvt.'
          },
          {
            lang: 'en',
            name: 'Subject',
            value: 'subject',
            order: 1,
            desc: 'Counting hours for the class. Two simultaneous activities count as halves.'
          },
          {
            lang: 'nb',
            name: 'Fag',
            value: 'subject',
            order: 1,
            desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Fag: Standard for undervisningstimer. Legges to eller flere fag i samme tidsrom fordeles tiden likt mellom fagene.</p><img style="width: 80%;" src="' + subjectNo + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Norsk og Matematikk i samme tidsrom i en klasse telles som 30 minutter norsk og 30 min matematikk.</p></div>'
          }
        ],
        'optional': [
          {
            lang: 'da',
            name: 'Valgfag/Hold <span class="do-bagde-break">UV-tid</span>',
            value: 'optional',
            order: 2,
            desc: 'Tæller UV-tid. Tæller 100%, uafhængigt af andre brikker i samme tidsrum i klassen.'
          },
          {
            lang: 'en',
            name: 'Optional grades/groups',
            value: 'optional',
            order: 2,
            desc: 'Fully counting and independent from other activities in the same time period.'
          },
          {
            lang: 'nb',
            name: 'Valgfag/gruppe',
            value: 'optional',
            order: 2,
            desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Valgfag/gruppe: Undervisningstimer som ikke teller fra andre fag. Er særlig nyttig for valgfag og tilvalgsfag. </p><img style="width: 80%;" src="' + optionalNo + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Spansk og Fransk i samme tidsrom telles som 60 min Spansk og 60 min Fransk.</p></div>'
          }
        ],
        'supplemental': [
          {
            lang: 'da',
            name: 'UUV <span class="do-bagde-break">UV-tid</span>',
            value: 'supplemental',
            desc: 'Tæller UV-tid. Og selvstændigt på understøttende undervisning.',
            order: 6
          },
          {
            lang: 'en',
            name: 'UUV',
            value: 'supplemental',
            desc: 'Tæller selvstændigt på understøttende undervisning.',
            order: 6
          },
          {
            lang: 'nb',
            name: 'UUV',
            value: 'supplemental',
            desc: 'Tæller selvstændigt på understøttende undervisning.',
            order: 6
          }
        ],
        'frame': [
          {
            lang: 'da',
            name: 'Temavisning',
            value: 'frame',
            order: 3,
            desc: 'Tæller ikke noget selv, men fagbrikker i samme tidsrum tæller 100%. Temavisning kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig, mens fag-brikker, der ligger samtidig med tema-brikken skjules for elever/forældre. '
          },
          {
            lang: 'en',
            name: 'Theme',
            value: 'frame',
            order: 3,
            desc: 'Can be used for marking themes and special days in the class schedule. The themed activity is visible for the pupils and parents, while classes that are overlapping the themed activity will not be visible. Classes are fully counting, and the themed activity is not.'
          },
          {
            lang: 'nb',
            name: 'Temavisning (Ramme)',
            value: 'frame',
            order: 3,
            desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Temavisning (ramme): Brukes til å markere temaer eller spesielle dager/fag i timeplanen. Timer lagt inn med denne fagtype er synlig for elever/foresatte, og kan med fordel legges i samme tidsrom som andre fag, og vil da skjule disse for elever/foresatte. Temavisning telles ikke som undervisningstimer, det gjør derimot fagene som er lagt i samme tidsrom.</p><img style="width: 80%;" src="' + frameNo + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: \'Idrettsdag’\' opprettes som Temavisning, og legges over fagene som normalt ligger i timeplanen. Lærere ser alle timene, mens elever/foresatte ser ‘Idrettsdag’ i timeplanen. Kan også brukes på samme måte for å markere tilvalgsfag eller valgfag for elever. Legger man en temavisning over for eksempel fire tilvalgsfag, vil dette gi en forenklet visning til elevene.</p></div>'
          }
        ],
        'break': [
          {
            lang: 'da',
            name: 'Pause <span class="do-bagde-break">UV-tid</span>',
            value: 'break',
            desc: 'Tæller UV-tid. Andre lektioner bør ikke overlappe med en pause.',
            order: 7
          },
          {lang: 'en', name: 'Break', value: 'break', desc: 'Subjects should not overlap with breaks.', order: 7},
          {lang: 'nb', name: 'Pause', value: 'break', desc: 'Andre timer bør ikke overlapper med en pause.', order: 7}
        ],
        'resource': [
          {
            lang: 'da',
            name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
            value: 'resource',
            order: 4,
            desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
          },
          {
            lang: 'en',
            name: 'Resource (hidden)',
            value: 'resource',
            order: 4,
            desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
          },
          {
            lang: 'nb',
            name: 'Ressurs (skjult)',
            value: 'resource',
            order: 4,
            desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
          }
        ],
        'person_resource': [
          {
            lang: 'da',
            name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
            value: 'person_resource',
            order: 4,
            desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
          },
          {
            lang: 'en',
            name: 'Resource (hidden)',
            value: 'person_resource',
            order: 4,
            desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
          },
          {
            lang: 'nb',
            name: 'Ressurs (skjult)',
            value: 'person_resource',
            order: 4,
            desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
          }
        ],
        'other_tasks': [
          {
            lang: 'da',
            name: 'Anden tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
            value: 'other_tasks',
            desc: 'Ikke undervisning',
            order: 13
          },
          {lang: 'en', name: 'Other tasks', value: 'other_tasks', desc: 'Not teaching', order: 13},
          {lang: 'nb', name: 'Annen tid', value: 'other_tasks', desc: 'Ikke undervisning', order: 13}
        ],
        'other_stuff': [
          {
            lang: 'da',
            name: 'Øvrig tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
            value: 'other_stuff',
            desc: 'Ikke undervisning, ikke elev-relateret.',
            order: 12
          },
          {
            lang: 'en',
            name: 'Additional tasks',
            value: 'other_stuff',
            desc: 'Not classes and teaching, non-pupil related.',
            order: 12
          },
          {
            lang: 'nb',
            name: 'Øvrig tid',
            value: 'other_stuff',
            desc: 'Ikke undervisning, ikke elevrelatert.',
            order: 12
          }
        ],
        'available': [
          {
            lang: 'da',
            name: 'Rådighedstime',
            value: 'available',
            desc: 'Brug til at vise, hvornår en underviser kan tage en vikartime',
            order: 11
          },
          {
            lang: 'nb',
            name: 'Rådighetstime',
            value: 'available',
            desc: ' Brukes til å vise når en underviser kan ta en vikartime',
            order: 11
          },
          {
            lang: 'en',
            name: 'On-Call',
            value: 'available',
            desc: 'The \'On-Call\' event indicates a timeslot when a teacher is available and ready to take over a course as a substitute. These events can be prioritized within the Substitute Management module, ensuring that available teachers can be quickly identified and assigned to cover classes as needed.',
            order: 11
          }
        ],
        'person_resource_visible': [
          {
            lang: 'da',
            name: 'Ressource (synlig) <span class="do-bagde-break">UV-tid</span>',
            value: 'person_resource_visible',
            order: 5,
            desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises i elev- og forældre visning.'
          },
          {
            lang: 'en',
            name: 'Resource (Visible)',
            value: 'person_resource_visible',
            order: 5,
            desc: 'Can be used to register teaching resources. Visible to students/parents.'
          },
          {
            lang: 'nb',
            name: 'Ressurs (Vises for elever)',
            value: 'person_resource_visible',
            order: 5,
            desc: '<p style="width: 400px">Ressurs (vises for elever): Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er synlig for elever/foresatte. Som fagtypen Ressurs, er denne også nyttig til å vise at det er ekstra personale til stede, f.eks en Miljøveileder, som også skal være synlig for elever/foresatte i timeplanen.</p>'
          }
        ],
        'club': [
          {lang: 'da', name: 'SFO tid', value: 'club', desc: 'Pædagogisk tid i SFO, FFO, DUS eller lignende', order: 8},
          {lang: 'en', name: 'SFO time', value: 'club', desc: 'Pedagogical time', order: 8},
          {lang: 'nb', name: 'SFO tid', value: 'club', desc: 'Pedagogisk tid', order: 8}
        ],
        'additional_tasks': [
          {
            lang: 'da',
            name: 'Øvrige opgaver',
            value: 'additional_tasks',
            desc: 'Tæller som Øvrige Opgaver. Ikke undervisning',
            order: 9
          },
          {lang: 'en', name: 'Not teaching', value: 'additional_tasks', desc: 'Not teaching', order: 9},
          {lang: 'nb', name: 'Øvrige oppgaver', value: 'additional_tasks', desc: 'Tæller som øvrige opgaver.', order: 9}
        ],
        'preparation': [
          {
            lang: 'da',
            name: 'Forberedelse',
            value: 'preparation',
            desc: 'Kan bruges til individuel eller fælles forberedelse (f.eks. teammøder m.m)',
            order: 10
          },
          {
            lang: 'en',
            name: 'Preparation',
            value: 'preparation',
            desc: 'Can be used for individual or joint preparation',
            order: 10
          },
          {
            lang: 'nb',
            name: 'Forberedelse',
            value: 'preparation',
            desc: 'Kan brukes til individuell eller felles forberedelse',
            order: 10
          }
        ],
        'pool': [
          {
            lang: 'da',
            name: 'Lokalpulje',
            value: 'pool',
            desc: 'Kan bruges til f.eks. udvikling, forberedelse, overlevering, opgaver i tilknytning til afslutning',
            order: 11
          },
          {
            lang: 'nb',
            name: 'Planleggingsdager',
            value: 'pool',
            desc: '',
            order: 11
          }
        ],
        'activity': [
          {
            lang: 'da',
            name: 'Aktivitet <span style="text-transform: initial">(m. reduktion)</span> <span class="do-bagde-break">UV-tid</span>',
            value: 'activity',
            desc: 'Bruges til at oprette aktiviteter i klasser, der skal reducere timepuljer fra andre fag.',
            order: 11
          }
        ],
        'reservation': [
          {
            lang: 'da',
            name: 'Reservation',
            value: 'reservation',
            desc: 'Bruges til f.eks. lokalebooking. Tæller intet - men blokerer blot et tidsrum i en kalender',
            order: 11
          },
          {
            lang: 'nb',
            name: 'Reservasjon',
            value: 'reservation',
            desc: 'Brukes til f.eks. rombestilling. Teller ingenting - men blokkerer bare et tidsrom i en kalender',
            order: 11
          },
          {
            lang: 'en',
            name: 'Reservation',
            value: 'reservation',
            desc: 'Used for e.g. room booking. Counts for nothing - but simply blocks a time slot in a calendar',
            order: 11
          }
        ]
      },
      kindergartenTypes: {
        'with_kids': [
          {lang: 'da', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11},
          {lang: 'en', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11},
          {lang: 'nb', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11}
        ],
        'without_kids': [
          {lang: 'da', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12},
          {lang: 'en', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12},
          {lang: 'nb', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12}
        ]
      },
      selectedtype: null,
      isTooltip: false,
      isTooltipPopperDone: false,
      activeSubjectTypeDesc: ''
    }
  },
  computed: {
    school () {
      return this.$store.state.activeSchool
    },
    schoolId () {
      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : this.school.id
    },
    locale () {
      return this.$store.getters.locale
    },
    isKindergarten () {
      return this.$store.getters.isKindergarten
    },
    isReductionsActive () {
      return this.$store.getters.isReductionsActive
    },
    activeSubjectTypes () {
      let arr = []
      let dbSubjectTypes = !this.isInTasks ? this.calSubjectTypes : this.calSubjectTypes.filter(type => !(type === 'other_stuff' || type === 'other_tasks'))
      const allTypes = this.isKindergarten ? this.kindergartenTypes : this.allTypes
      dbSubjectTypes.forEach(activeType => {
        if (allTypes[activeType] && allTypes[activeType].filter(subjectType => subjectType.lang === this.locale)[0]) {
          arr.push(allTypes[activeType].filter(subjectType => subjectType.lang === this.locale)[0])
        }
      })
      if (!this.isSchoolFeatureLocalePool) {
        arr = arr.filter(subjectType => subjectType.value !== 'pool')
      }
      if (this.calendarType === 'room') {
        arr = arr.filter(subjectType => subjectType.value !== 'subject')
      }
      if (this.calendarType === 'klass') {
        const idx = arr.findIndex(subjectType => subjectType.value === 'additional_tasks' && subjectType.lang === 'da')
        if (idx > -1) {
          arr[idx]['name'] = 'Tilsyn / Øvrige opgaver'
        }
      }
      return arr.filter(item => !this.isReductionsActive ? item.value !== 'activity' : true).sort((a, b) => (a.order > b.order) ? 1 : -1)
    },
    isSchoolFeatureLocalePool () {
      return this.$store.getters.isSchoolFeatureLocalePool
    }
  },
  watch: {
    calendarType () {
      this.readSubjectTypes(this.calendarType)
    },
    selectedtype (val) {
      this.$emit('change', val)
    },
    activeSubjectTypes () {
      const idx = this.activeSubjectTypes.findIndex(subjectType => subjectType.value === this.subjectType)
      if (idx > 0 && this.subjectType) {
        this.selectedtype = this.subjectType
      } else {
        this.selectedtype = this.activeSubjectTypes[0].value
      }
    }
  },
  methods: {
    createPopper (evt) {
      const childPopper = this.$refs.child_popper
      document.getElementById('djs-content-container').appendChild(childPopper)
      createPopper(evt.target, childPopper, {
        placement: 'right',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: ({placement, reference, popper}) => {
                return [0, 5]
              }
            }
          }
        ]
      })
    },
    showTooltip (desc, evt) {
      this.activeSubjectTypeDesc = desc
      this.isTooltip = true
      this.$nextTick(_ => {
        this.createPopper(evt)
        this.isTooltipPopperDone = true
      })
    },
    hideTooltip () {
      this.activeSubjectTypeDesc = ''
      this.isTooltip = false
      this.isTooltipPopperDone = false
    },
    readSubjectTypes (calType) {
      const schoolCountry = this.school.country
      docendo.subjectsForCalendarType(calType, schoolCountry, success => {
        this.calSubjectTypes = success
      }, failure => {
        console.log('failed')
      })
    }
  },
  beforeMount () {
    if (this.activeSubjectTypes && this.activeSubjectTypes[0]) {
      this.subjectType ? this.selectedtype = this.subjectType : this.selectedtype = this.activeSubjectTypes[0].value
    }
  },
  mounted () {
    this.readSubjectTypes(this.calendarType)
  },
  beforeDestroy () {
    // remove the dropdown from the DOM
    const childPopper = this.$refs.child_popper
    if (childPopper) {
      childPopper.remove()
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';


.subject-types {
  display: inline-flex;
  flex-direction: column;
  border-radius: 4px;
  min-width: 300px;
  width: 100%;
}

.subject-types:focus-within {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 0px 0px 2px rgba(58, 151, 212, 0.5) !important;
}

.subject-types__type {
  position: relative;
  display: inline-flex;
  align-items: center;
  line-height: 16px;
  transition: color 0.25s;
  cursor: pointer;
  padding: 1rem;
  margin-bottom: 0;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-width: 1px 1px 0 1px;
}

.subject-types__type.subject-types__type--selected + .subject-types__type {
  border-top: none;
}

.subject-types__type.subject-types__type--selected,
.subject-types .subject-types__type.subject-types__type--selected:last-child {
  background: #eff2ff;
  border: 1px solid #c8d2fe;
}

.subject-types__type > input[type="radio"] {
  width: auto;
  padding-right: 8px;
}

.subject-types__type > input[type="radio"]:checked + label {
  color: var(--dark-blue);
}

.subject-types__type label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
  font-size: 12px;
  padding-left: 10px;
  cursor: pointer;
  transition: color 0.25s;
  letter-spacing: .075rem;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1rem;
  color: #a2a3a6;
}

.desc {
  position: absolute;
  right: 1rem;
  padding-left: 10px;
  display: flex;
  cursor: help;
}

.desc__info {
  z-index: 123123;
  position: absolute;
  bottom: 0;
  left: 100%;
  min-width: 200px;
  max-width: 420px;
  background-color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: opacity 0.25s, transform 0.25s;
  font-weight: bold;
}

.subject-types__type:hover label {
  color: var(--dark-blue);
}

.popper-container {
  position: absolute;
  z-index: 123123;
}

.subject-types .subject-types__type:first-child {
  border-radius: 4px 4px 0 0;
}

.subject-types .subject-types__type:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 1px solid #e5e7eb;
}

.subject-types .subject-types__type:only-child {
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// SubjectFormSubjectType.vue?452ab4ee